import BarChart from "components/charts/BarChart";
import { barChartOptionsDailyTraffic } from "config/charts";
import Card from "components/card";
import { useState } from 'react';
import { SwipeStats } from 'utils/dashboardDataHelper';
import { MdBarChart, MdTrendingUp } from 'react-icons/md';

const LearningDiscovery = () => {
  const [swipeStats] = useState<SwipeStats>({
    totalSwipes: 23847,
    typeCounts: {
      "Quiz": 8934,
      "Tips": 7123,
      "Links": 4892,
      "Others": 2898
    },
    barChartData: [{ name: "Module Types", data: [8934, 7123, 4892, 2898] }],
  });

  // Calculate additional metrics
  const formatNumber = (num: number) => {
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}k`;
    }
    return num.toString();
  };

  const getLearningData = () => {
    // Mock data for learning metrics - in real implementation, this would come from the API
    const totalViews = swipeStats.totalSwipes;
    
    return { totalViews };
  };

  const { totalViews } = getLearningData();

  return (
    <Card extra="p-5 text-dm lg:h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-500/10 text-brand-500">
          <MdTrendingUp className="text-xl" />
        </div>
        <div>
          <p className="text-lg font-bold text-navy-700 dark:text-white">
            Learning Discovery
          </p>
          <p className="text-sm text-gray-600">Mentorship exploration patterns</p>
        </div>
      </div>

      {/* Learning Metrics */}
      <div className="mb-4">
        <div className="flex items-center gap-4 p-3 border rounded-lg bg-blue-50 dark:bg-navy-800 w-full">
          <MdBarChart className="text-blue-500 text-2xl flex-shrink-0" />
          <div className="flex-1">
            <div className="text-2xl font-bold text-navy-700 dark:text-white">{formatNumber(totalViews)}</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Total Views</div>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="flex-1 w-full overflow-hidden min-h-[180px]">
        <div className="mb-2">
          <p className="text-sm text-gray-600">Learning module types engaged</p>
        </div>
        {swipeStats.barChartData[0].data.length > 0 && (
          <BarChart
            chartData={swipeStats.barChartData}
            chartOptions={barChartOptionsDailyTraffic(Object.keys(swipeStats.typeCounts))}
          />
        )}
      </div>
    </Card>
  );
};

export default LearningDiscovery;
